import React from 'react';
import { Helmet } from 'react-helmet-async';

export const EMPTY_TAG = 'EMPTY_TAG';

const DEFAULT_META = {
  title: 'Prerender.io',
  description: 'Prerender.io is a service that helps search engines crawl and index your website.',
  ogTitle: 'Prerender.io',
  ogDescription: 'Prerender.io is a service that helps search engines crawl and index your website.',
  ogImage: 'https://prerender.io/wp-content/uploads/prerender-logo-1.svg',
  ogUrl: 'https://prerender.io',
  robots: 'index, follow',
  canonical: 'https://prerender.io',
};
const checkEmptyTag = (metaTag: string) => (metaTag === EMPTY_TAG ? undefined : metaTag);

export type MetaTagsProps = {
  tags?: {
    title?: string;
    description?: string;
    ogTitle?: string;
    ogDescription?: string;
    ogImage?: string;
    ogUrl?: string;
    robots?: string;
    canonical?: string;
  };
};
function MetaTags(props: MetaTagsProps) {
  const { tags } = props;
  const tag = tags || {};
  const title = checkEmptyTag(tag.title || DEFAULT_META.title);
  const description = checkEmptyTag(tag.description || DEFAULT_META.description);
  const ogTitle = checkEmptyTag(tag.ogTitle || DEFAULT_META.ogTitle);
  const ogDescription = checkEmptyTag(tag.ogDescription || DEFAULT_META.ogDescription);
  const ogImage = checkEmptyTag(tag.ogImage || DEFAULT_META.ogImage);
  const ogUrl = checkEmptyTag(tag.ogUrl || DEFAULT_META.ogUrl);
  const robots = checkEmptyTag(tag.robots || DEFAULT_META.robots);
  const canonical = checkEmptyTag(tag.canonical || DEFAULT_META.canonical);

  return (
    <Helmet>
      <title>{title}</title>

      <meta id="fb:app_id" content="" />
      <meta id="meta-description" name="description" content={description} />
      <meta id="og-title" property="og:title" content={ogTitle} />
      <meta id="og-description" property="og:description" content={ogDescription} />
      <meta id="og-image" property="og:image" content={ogImage} />
      <meta id="og-url" property="og:url" content={ogUrl} />
      <meta id="og-type" property="og:type" content="website" />
      {robots && <meta name="robots" content={robots} />}
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
}

export default MetaTags;
